import Icon from '../components/Icon.vue'

Icon.register({"cloud-upload-alt":{"width":640,"height":512,"paths":[{"d":"M640 352C640 422.7 582.7 480 512 480H144C64.5 480 0 415.5 0 336 0 273.2 40.2 219.8 96.2 200.1A163.7-163.7 0 0 0 96 192C96 103.6 167.6 32 256 32 315.3 32 367 64.2 394.7 112.2 409.9 102 428.3 96 448 96 501 96 544 139 544 192 544 204.2 541.7 215.8 537.6 226.6 596 238.4 640 290.1 640 352zM404.7 260.7L299.3 155.3C293.1 149.1 282.9 149.1 276.7 155.3L171.3 260.7C161.2 270.8 168.4 288 182.6 288H248V400C248 408.8 255.2 416 264 416H312C320.8 416 328 408.8 328 400V288H393.4C407.6 288 414.8 270.8 404.7 260.7z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/cloud-upload-alt.js
// module id = null
// module chunks = 